export const getLocale = (locale) => {
  if (locale != 'fr') {
    return 'en'
  }

  return locale
}
